/** clientList 接口 Result 为分页对象 { list, total, page_num, ... } */
export function clientListRows(result) {
  if (!result) return [];
  if (Array.isArray(result)) return result;
  if (Array.isArray(result.list)) return result.list;
  return [];
}

export const CLIENT_LIST_QUERY_PAGE = {
  page_num: '1',
  page_amount: '10',
  page_size: '100',
};
